import type { CartItem } from '../../api/cart/types'

export function hasOutOfStockItem(items: CartItem[]): boolean {
  return items.some((item) => item.available === 'no')
}
